import { cn } from '../../lib/cn'

// Literal classes so Tailwind's content scanner keeps them.
const TINT_BG = ['bg-tint0', 'bg-tint1', 'bg-tint2', 'bg-tint3', 'bg-tint4', 'bg-tint5']

interface AvatarProps {
  initials: string
  tintIndex: number
  /** Show the presence dot at bottom-right. */
  showDot?: boolean
  online?: boolean
  /** Pixel diameter (default 24, matching the sidebar). */
  size?: number
  /** Tailwind border-color class matching the surrounding surface (dot ring). */
  ringClass?: string
  /** Rounded-square glyph (gaming roster) vs circle (people). */
  square?: boolean
  className?: string
}

export function Avatar({
  initials,
  tintIndex,
  showDot = false,
  online = false,
  size = 24,
  ringClass = 'border-paper-panel',
  square = false,
  className,
}: AvatarProps) {
  const tint = TINT_BG[((tintIndex % 6) + 6) % 6]
  const fontSize = Math.max(9, Math.round(size * 0.42))
  return (
    <span className={cn('relative inline-flex flex-none', className)} style={{ width: size, height: size }}>
      <span
        className={cn(
          'flex h-full w-full items-center justify-center font-sans font-semibold text-[#332a20]',
          square ? 'rounded-[7px]' : 'rounded-full',
          tint,
        )}
        style={{ fontSize }}
      >
        {initials}
      </span>
      {showDot && (
        <span
          className={cn(
            'absolute -bottom-px -right-px h-[9px] w-[9px] rounded-full border-2',
            ringClass,
            online ? 'bg-moss' : 'bg-[#c9bda9]',
          )}
        />
      )}
    </span>
  )
}
